/**
 * @generated SignedSource<<967a42e4479ab685e2fd48e4bc5530ba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type PeriodUnit = "DAY" | "MONTH" | "WEEK" | "YEAR";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "AI_STUDIO" | "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type testPageQuery$variables = {
  canAccessOrders: boolean;
  canReadChannels: boolean;
  canReadStandaloneSites: boolean;
  canReadSubscription: boolean;
  productId: string;
};
export type testPageQuery$data = {
  readonly addons: ReadonlyArray<{
    readonly addonID: number;
    readonly billingSystemAddonID: string | null;
    readonly code: string;
    readonly description: string;
    readonly name: string;
    readonly periodUnit: PeriodUnit;
    readonly price: number;
    readonly published: boolean;
    readonly rates: ReadonlyArray<{
      readonly feeValue: number;
    }>;
    readonly sellerID: number | null;
  }>;
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly ecommerceSettings: {
          readonly definitiveUrl: string | null;
          readonly ecommerceName: ECommerce;
          readonly remoteUrl: string | null;
        } | null;
        readonly id: string;
      };
      readonly salesChannelID: string;
    }>;
    readonly canAddAdditionalCode: boolean;
    readonly code: string;
    readonly colors: ReadonlyArray<{
      readonly code: string | null;
      readonly colorCode: string | null;
      readonly colorID: number;
      readonly name: string;
    }>;
    readonly id: string;
    readonly iframeUrl: {
      readonly copyUrl: string;
      readonly testUrl: string;
    };
    readonly isDemo: boolean;
    readonly modelColorMappings: ReadonlyArray<{
      readonly colorID: number;
      readonly merchantCode: string;
      readonly salesChannelID: string;
    }>;
    readonly name: string;
    readonly printTypes: ReadonlyArray<{
      readonly printTypeID: number;
    }>;
    readonly provider: ProductProvider;
    readonly salesChannel: {
      readonly ecommerceSettings: {
        readonly definitiveUrl: string | null;
        readonly ecommerceName: ECommerce;
        readonly hasProductsApi: boolean;
        readonly isMarketplace: boolean;
        readonly productsApi: string | null;
        readonly remoteUrl: string | null;
      } | null;
      readonly id: string;
    };
    readonly statusID: number;
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
  readonly overviewSubscription?: {
    readonly chargeBeeSubscription: {
      readonly currencyCode: string | null;
    } | null;
  } | null;
  readonly salesChannels?: ReadonlyArray<{
    readonly detail: {
      readonly id: string;
      readonly properties: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly ecommerceSettings: {
      readonly currencyCode: string | null;
      readonly definitiveUrl: string | null;
      readonly ecommerceID: number;
      readonly ecommerceName: ECommerce;
      readonly hasProductsApi: boolean;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly sellerUserInterfaces: {
    readonly nodes: ReadonlyArray<{
      readonly isDefault: boolean;
      readonly userInterfaceId: number | null;
    } | null> | null;
  } | null;
  readonly shopifyAuthEcommerceSettings: {
    readonly isTestStore: boolean;
  } | null;
  readonly standaloneSites?: ReadonlyArray<{
    readonly salesChannelGlobalID: string;
  }>;
  readonly subscription: {
    readonly inTrial: boolean;
    readonly isOverMaxNumTestOrders?: boolean;
    readonly maxNumTestOrders?: number | null;
    readonly maxProducts: {
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
  readonly testOrderNumberInBillingDate?: number;
};
export type testPageQuery = {
  response: testPageQuery$data;
  variables: testPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canAccessOrders"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadChannels"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadStandaloneSites"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadSubscription"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addonID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingSystemAddonID",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodUnit",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeValue",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ChargeBeeSubscription",
  "kind": "LinkedField",
  "name": "chargeBeeSubscription",
  "plural": false,
  "selections": [
    (v15/*:: as any*/)
  ],
  "storageKey": null
},
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDemo",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelPrintType",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "colors",
  "plural": true,
  "selections": [
    (v23/*:: as any*/),
    (v8/*:: as any*/),
    (v10/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketplaceIframe",
  "kind": "LinkedField",
  "name": "iframeUrl",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "copyUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMarketplace",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddAdditionalCode",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelColorMapping",
  "kind": "LinkedField",
  "name": "modelColorMappings",
  "plural": true,
  "selections": [
    (v23/*:: as any*/),
    (v34/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "merchantCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "condition": "canAccessOrders",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testOrderNumberInBillingDate",
      "storageKey": null
    }
  ]
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "condition": "canAccessOrders",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxNumTestOrders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOverMaxNumTestOrders",
      "storageKey": null
    }
  ]
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inTrial",
  "storageKey": null
},
v41 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetail",
  "kind": "LinkedField",
  "name": "detail",
  "plural": false,
  "selections": [
    (v18/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetailProperties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        (v8/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelGlobalID",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ShopifyAuthEcommerceSettings",
  "kind": "LinkedField",
  "name": "shopifyAuthEcommerceSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestStore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterfaceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addons",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v14/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "canReadSubscription",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OverviewSubscription",
            "kind": "LinkedField",
            "name": "overviewSubscription",
            "plural": false,
            "selections": [
              (v16/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v17/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v18/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v21/*:: as any*/),
          (v22/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              (v18/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v26/*:: as any*/),
                  (v27/*:: as any*/),
                  (v28/*:: as any*/),
                  (v29/*:: as any*/),
                  (v30/*:: as any*/),
                  (v31/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*:: as any*/),
              (v34/*:: as any*/),
              (v35/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v31/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v36/*:: as any*/)
        ],
        "storageKey": null
      },
      (v37/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v38/*:: as any*/),
          (v39/*:: as any*/),
          (v40/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "canReadChannels",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v41/*:: as any*/),
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannels",
            "plural": true,
            "selections": [
              (v18/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v42/*:: as any*/),
                  (v26/*:: as any*/),
                  (v30/*:: as any*/),
                  (v29/*:: as any*/),
                  (v27/*:: as any*/),
                  (v31/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": "salesChannels(status:\"ACTIVE\")"
          }
        ]
      },
      {
        "condition": "canReadStandaloneSites",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StandaloneSiteInfo",
            "kind": "LinkedField",
            "name": "standaloneSites",
            "plural": true,
            "selections": [
              (v44/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v45/*:: as any*/),
      {
        "alias": null,
        "args": (v46/*:: as any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v47/*:: as any*/),
              (v48/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sellerUserInterfaces(first:1)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "testPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addons",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v14/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "canReadSubscription",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OverviewSubscription",
            "kind": "LinkedField",
            "name": "overviewSubscription",
            "plural": false,
            "selections": [
              (v16/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v17/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v18/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v21/*:: as any*/),
          (v22/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              (v18/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v26/*:: as any*/),
                  (v27/*:: as any*/),
                  (v28/*:: as any*/),
                  (v29/*:: as any*/),
                  (v30/*:: as any*/),
                  (v31/*:: as any*/),
                  (v18/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*:: as any*/),
              (v34/*:: as any*/),
              (v35/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v31/*:: as any*/),
                      (v18/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v36/*:: as any*/)
        ],
        "storageKey": null
      },
      (v37/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v38/*:: as any*/),
          (v39/*:: as any*/),
          (v40/*:: as any*/),
          (v18/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "canReadChannels",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v41/*:: as any*/),
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannels",
            "plural": true,
            "selections": [
              (v18/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v42/*:: as any*/),
                  (v26/*:: as any*/),
                  (v30/*:: as any*/),
                  (v29/*:: as any*/),
                  (v27/*:: as any*/),
                  (v31/*:: as any*/),
                  (v15/*:: as any*/),
                  (v18/*:: as any*/)
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": "salesChannels(status:\"ACTIVE\")"
          }
        ]
      },
      {
        "condition": "canReadStandaloneSites",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StandaloneSiteInfo",
            "kind": "LinkedField",
            "name": "standaloneSites",
            "plural": true,
            "selections": [
              (v44/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v45/*:: as any*/),
      {
        "alias": null,
        "args": (v46/*:: as any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v47/*:: as any*/),
              (v48/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sellerUserInterfaces(first:1)"
      }
    ]
  },
  "params": {
    "cacheID": "90bb2298cbb6694110f4af7dc4d21b42",
    "id": null,
    "metadata": {},
    "name": "testPageQuery",
    "operationKind": "query",
    "text": "query testPageQuery(\n  $productId: ID!\n  $canAccessOrders: Boolean!\n  $canReadChannels: Boolean!\n  $canReadStandaloneSites: Boolean!\n  $canReadSubscription: Boolean!\n) {\n  addons {\n    addonID\n    billingSystemAddonID\n    description\n    name\n    periodUnit\n    code\n    published\n    price\n    sellerID\n    rates {\n      feeValue\n      id\n    }\n    id\n  }\n  overviewSubscription @include(if: $canReadSubscription) {\n    chargeBeeSubscription {\n      currencyCode\n    }\n    id\n  }\n  model(id: $productId) {\n    id\n    name\n    code\n    provider\n    statusID\n    isDemo\n    printTypes {\n      printTypeID\n    }\n    colors {\n      colorID\n      name\n      code\n      colorCode\n    }\n    iframeUrl {\n      testUrl\n      copyUrl\n    }\n    salesChannel {\n      id\n      ecommerceSettings {\n        ecommerceName\n        remoteUrl\n        productsApi\n        hasProductsApi\n        isMarketplace\n        definitiveUrl\n        id\n      }\n    }\n    zakekeEnvironment\n    canAddAdditionalCode\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        id\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          definitiveUrl\n          id\n        }\n      }\n    }\n    modelColorMappings {\n      colorID\n      salesChannelID\n      merchantCode\n    }\n  }\n  testOrderNumberInBillingDate @include(if: $canAccessOrders)\n  subscription {\n    maxProducts {\n      pricingVersion\n      numPublishedProducts\n      maxProducts\n      numProducts\n    }\n    maxNumTestOrders @include(if: $canAccessOrders)\n    isOverMaxNumTestOrders @include(if: $canAccessOrders)\n    inTrial\n    id\n  }\n  salesChannels(status: ACTIVE) @include(if: $canReadChannels) {\n    id\n    ecommerceSettings {\n      ecommerceID\n      ecommerceName\n      isMarketplace\n      hasProductsApi\n      remoteUrl\n      definitiveUrl\n      currencyCode\n      id\n    }\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n  }\n  standaloneSites @include(if: $canReadStandaloneSites) {\n    salesChannelGlobalID\n    id\n  }\n  shopifyAuthEcommerceSettings {\n    isTestStore\n  }\n  sellerUserInterfaces(first: 1) {\n    nodes {\n      isDefault\n      userInterfaceId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d0329690a95a6ef1d6202df9dbb0eed";

export default node;
